<template>
  <div class="work-order-list-container">
    <div v-if="fullscreenLoading" class="fullscreen-loading-overlay">
      <a-spin :loading="fullscreenLoading" tip="数据导出中，请稍候..." class="fullscreen-spin-container">
        <template #icon>
          <icon-loading />
        </template>
      </a-spin>
    </div>
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="工单编码" label-col-flex="80px">
              <a-input v-model="queryForm.workorderCode" placeholder="请输入工单编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="门店名称" label-col-flex="80px">
              <a-input v-model="queryForm.storeName" placeholder="请输入门店名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="工单状态" label-col-flex="80px">
              <a-select v-model="queryForm.workStatuses" :options="workOrderStatusOptions" placeholder="请选择工单状态"
                        allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 220 }"
                        multiple>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-space>
              <a-button type="primary" @click="handleQuery" :loading="loading">
                <template #icon>
                  <icon-search style="stroke: #fff"/>
                </template>
                搜索
              </a-button>
              <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              <a-button type="text" @click="()=>{collapsed = !collapsed}">
                <template #icon>
                  <icon-down v-if="collapsed"/>
                  <icon-up v-else/>
                </template>
                {{ collapsed ? '展开' : '收起' }}
              </a-button>
            </a-space>
          </a-grid-item>
          <!-- 任务类型筛选条件已注释 -->
          <!--
          <a-grid-item>
            <a-form-item label="任务类型" label-col-flex="80px">
              <a-select v-model="queryForm.taskType" :options="taskTypeOptions" placeholder="请选择任务类型" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 260 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          -->
          <a-grid-item>
            <a-form-item label="所属门店" label-col-flex="80px">
              <a-select v-model="queryForm.storeId" :options="customerStoreOptions" placeholder="请选择所属门店"
                        allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="服务人员" label-col-flex="80px">
              <a-select v-model="queryForm.servicePersonIds" :options="userOptions"
                        placeholder="请选择服务人员" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="审批人员" label-col-flex="80px">
              <a-select v-model="queryForm.approverIds" :options="userOptions"
                        placeholder="请选择审批人员" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
<!--          <a-grid-item>
            <a-form-item label="签到状态" label-col-flex="80px">
              <a-select v-model="queryForm.checkinStatuses" :options="checkinStatusOptions" placeholder="请选择签到状态"
                        allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 220 }"
                        multiple>
              </a-select>
            </a-form-item>
          </a-grid-item>-->
          <a-grid-item>
            <a-form-item label="工单类型" label-col-flex="80px">
              <a-select v-model="queryForm.workorderType" :options="workOrderTypeOptions" placeholder="请选择工单类型"
                        allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 260 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="省" label-col-flex="80px">
              <a-select
                  v-model="queryForm.province"
                  :options="provinceOptions"
                  placeholder="请选择省"
                  allow-clear
                  allow-search
                  @change="handleProvinceChange"
              />
            </a-form-item>
          </a-grid-item>
          <a-grid-item>

            <a-form-item label="市" label-col-flex="80px">
              <a-select
                  v-model="queryForm.city"
                  :options="cityOptions"
                  placeholder="请选择市"
                  allow-clear
                  allow-search
                  @change="handleCityChange"
              />
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="区" label-col-flex="80px">
              <a-select
                  v-model="queryForm.district"
                  :options="districtOptions"
                  placeholder="请选择区"
                  allow-clear
                  allow-search
              />
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="工作类别" label-col-flex="80px">
              <a-select v-model="queryForm.workCategory" :options="workCategoryOptions" placeholder="请选择工作类别"
                        allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 260 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="项目服务单" label-col-flex="80px">
              <a-select v-model="queryForm.projectServiceOrderId" :options="projectServiceOrderOptions"
                        placeholder="请选择项目服务单" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="时间筛选类型" label-col-flex="80px">
              <a-select v-model="queryForm.timeRangeType" :options="timeRangeTypeOptions" placeholder="时间筛选类型">

              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="计划时间段" label-col-flex="80px">
              <a-range-picker v-model="serviceTimeRange" :placeholder="['从','至']" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <!--          <a-grid-item>
                      <a-form-item label="审批状态" label-col-flex="80px">
                        <a-select v-model="queryForm.approvalStatus" :options="approvalStatusOptions" placeholder="请选择审批状态"
                                  allow-clear
                                  :allow-search="{ retainInputValue: false }"
                                  :virtual-list-props="{ height: 220 }">
                        </a-select>
                      </a-form-item>
                    </a-grid-item>-->
          <!--          <a-grid-item>
                      <a-form-item label="工单开始时间" label-col-flex="80px">
                        <a-range-picker v-model="workStartTimeRange" :placeholder="['从','至']" class="input" allow-clear/>
                      </a-form-item>
                    </a-grid-item>
                    <a-grid-item>
                      <a-form-item label="工单结束时间" label-col-flex="80px">
                        <a-range-picker v-model="workEndTimeRange" :placeholder="['从','至']" class="input" allow-clear/>
                      </a-form-item>
                    </a-grid-item>-->
          <!--          <a-grid-item>
                      <a-form-item label="联系人" label-col-flex="80px">
                        <a-input v-model="queryForm.contactPerson" placeholder="请输入联系人" class="input" allow-clear/>
                      </a-form-item>
                    </a-grid-item>-->
          <!--          <a-grid-item>
                      <a-form-item label="是否协同" label-col-flex="100px">
                        <a-select v-model="queryForm.isOvertime" :options="isOvertimeOptions" placeholder="请选择" allow-clear>
                          <a-option value="">全部</a-option>
                        </a-select>
                      </a-form-item>
                    </a-grid-item>-->
          <!--          <a-grid-item>
                      <a-form-item label="单次服务人时" label-col-flex="100px">
                        <a-input-group>
                          <a-input-number v-model="queryForm.unitServiceHoursLeftRange" placeholder="最小值" :hide-button="true"
                                          allow-clear/>
                          <a-input
                              :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }"
                              :bordered="false" :readonly="true" disabled :default-value="'-'"/>
                          <a-input-number v-model="queryForm.unitServiceHoursRightRange" placeholder="最大值" :hide-button="true"
                                          allow-clear/>
                        </a-input-group>
                      </a-form-item>
                    </a-grid-item>-->
          <!--          <a-grid-item>-->
          <!--            &lt;!&ndash; int &ndash;&gt;-->
          <!--            <a-form-item label="总需服务次数" label-col-flex="100px">-->
          <!--              <a-input-group>-->
          <!--                <a-input-number v-model="queryForm.totalServiceCountLeftRange"  placeholder="最小值" :hide-button="true" :precision="0" allow-clear />-->
          <!--                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />-->
          <!--                <a-input-number v-model="queryForm.totalServiceCountRightRange"  placeholder="最大值" :hide-button="true" :precision="0" allow-clear />-->
          <!--              </a-input-group>-->
          <!--            </a-form-item>-->
          <!--          </a-grid-item>-->
          <!--          <a-grid-item>-->
          <!--            &lt;!&ndash; int &ndash;&gt;-->
          <!--            <a-form-item label="已完成服务次数" label-col-flex="100px">-->
          <!--              <a-input-group>-->
          <!--                <a-input-number v-model="queryForm.completedServiceCountLeftRange"  placeholder="最小值" :hide-button="true" :precision="0" allow-clear />-->
          <!--                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />-->
          <!--                <a-input-number v-model="queryForm.completedServiceCountRightRange"  placeholder="最大值" :hide-button="true" :precision="0" allow-clear />-->
          <!--              </a-input-group>-->
          <!--            </a-form-item>-->
          <!--          </a-grid-item>-->
          <!--          <a-grid-item>
                      &lt;!&ndash; 小数点 &ndash;&gt;
                      <a-form-item label="单次金额" label-col-flex="100px">
                        <a-input-group>
                          <a-input-number v-model="queryForm.unitPriceLeftRange" placeholder="最小值" :hide-button="true"
                                          allow-clear/>
                          <a-input
                              :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }"
                              :bordered="false" :readonly="true" disabled :default-value="'-'"/>
                          <a-input-number v-model="queryForm.unitPriceRightRange" placeholder="最大值" :hide-button="true"
                                          allow-clear/>
                        </a-input-group>
                      </a-form-item>
                    </a-grid-item>-->
        </a-grid>
      </a-form>
    </canvas-glass-card>

    <a-space/>

    <!-- 项目工单列表表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">项目工单列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="350px">
            <a-row flex="80px" justify="end" :wrap="false">
              <!--              <a-button type="primary" @click="importWorkOrderInfo()">
                              <template #icon>
                                <icon-to-bottom style="stroke: #fff;"/>
                              </template>
                              导入
                            </a-button>-->
              <a-button type="primary" @click="exportWorkOrderInfo()">
                <template #icon>
                  <icon-to-top style="stroke: #fff"/>
                </template>
                导出
              </a-button>
              <a-button type="primary" @click="addWorkOrder()">
                <template #icon>
                  <icon-plus style="stroke: #fff"/>
                </template>
                新增
              </a-button>
              <a-tooltip content="列设置">
                <a-button type="text" @click="showColumnSetting = true">
                  <template #icon>
                    <icon-settings/>
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip content="刷新">
                <a-button type="text" @click="fetchTableData">
                  <template #icon>
                    <icon-refresh/>
                  </template>
                </a-button>
              </a-tooltip>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- 项目工单列表表格 -->
      <a-table
          ref="woListTable"
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          :scroll="{ x: 1000 }"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :row-selection="{
            type: 'radio'
          }"
          @row-click="(row)=>{$refs.woListTable.select(row.id, true);console.log('row-click',arguments)}"
          :hoverable="true"
          v-model:selectedKeys="selectedRowKeys"
      >
        <!-- 任务类型插槽已注释 -->
        <!--
        <template #taskType="{ record }">
          {{ getTaskTypeText(record.taskType) }}
        </template>
        -->

        <template #storeId="{ record }">
          {{ getStoreName(record.storeId) }}
        </template>
        <template #serviceTime="{ record }">
          {{ formatDate(record.serviceTime) }}
        </template>

        <template #workCategory="{ record }">
          {{ getWorkCategoryText(record.workCategory) }}
        </template>

        <template #projectServiceOrderId="{ record }">
          {{ getProjectServiceOrderText(record.projectServiceOrderId) }}
        </template>

        <template #workorderType="{ record }">
          {{ getWorkorderTypeText(record.workorderType) }}
        </template>

        <template #workStatus="{ record }">
          <a-tag :color="getWorkStatusColor(record.workStatus)">
            {{ getWorkStatusText(record.workStatus) }}
          </a-tag>
        </template>

        <template #approvalStatus="{ record }">
          <a-tag :color="getApprovalStatusColor(record.approvalStatus)">
            {{ getApprovalStatusText(record) }}
          </a-tag>
        </template>

        <template #invalidCount="{ record }">
          <a-tag v-for=" item in record.checkinStatusList"  :color="getCheckinStatusColor(item)">
            {{ getCheckinStatusText(item) }}
          </a-tag>
        </template>

        <template #urgent="{ record }">
          <a-tag :color="record.urgent ? 'red' : 'blue'">
            {{ record.urgent ? '紧急' : '普通' }}
          </a-tag>
        </template>

        <template #estimatedDuration="{ record }">
          {{ formatDuration(record.estimatedDuration) }}
        </template>

        <template #actualDuration="{ record }">
          {{ formatDuration(record.actualDuration) }}
        </template>

        <template #startTime="{ record }">
          {{ formatDateTime(record.startTime) }}
        </template>

        <template #endTime="{ record }">
          {{ formatDateTime(record.endTime) }}
        </template>

        <template #createBy="{ record }">
          {{ getUserText(record.createBy) }}
        </template>

        <template #createTime="{ record }">
          {{ formatDateTime(record.createTime) }}
        </template>

        <template #servicePersonIds="{ record }">
          {{ getUserText(record.servicePersonIds) }}
        </template>
        <template #approverIds="{ record }">
          {{ getUserText(record.approverIds) }}
        </template>

        <template #action="{ record }">
          <a-space>
            <!-- 详情 -->
            <a-button type="text" size="mini" status="normal" @click="showInfoBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-eye/>
              </template>
              详情
            </a-button>
            <!-- 查看pdf -->
            <a-button type="text" size="mini" status="normal" @click="showPdfView(record)"
                      :disabled="record.workStatus==='1' || record.workStatus==='2'"
                      class="button-table-option">

              <template #icon>
                <icon-eye/>
              </template>
              pdf
            </a-button>
            <!-- 编辑 -->
            <a-button type="text" size="mini" status="success" @click="editWorkOrder(record)"
                      class="button-table-option">
              <template #icon>
                <icon-edit/>
              </template>
              编辑
            </a-button>
            <!-- 审批 -->
            <a-button type="text" size="mini" status="normal" :disabled="approveButtonStatus(record)"
                      @click="approveWorkOrder(record)"
                      class="button-table-option">
              <template #icon>
                <icon-check/>
              </template>
              审批
            </a-button>
            <!-- 更多操作 -->
            <a-dropdown trigger="click">
              <a-button type="text" size="mini" class="button-table-option">更多</a-button>
              <template #content>
                <!--                <a-doption @click="convertTempToNormal(record)" v-if="record.workorderType==='5'">
                                  <a-button type="text" size="mini" status="normal" class="button-table-option">
                                    <template #icon>
                                      <icon-swap/>
                                    </template>
                                    临时工单转普通工单
                                  </a-button>
                                </a-doption>
                                <a-doption @click="convertNormalToTemp(record)" v-else>
                                  <a-button type="text" size="mini" status="normal" class="button-table-option">
                                    <template #icon>
                                      <icon-swap/>
                                    </template>
                                    普通工单转临时工单
                                  </a-button>
                                </a-doption>
                                <a-doption @click="convertCollaborativeToNormal(record)" v-if="record.workCategory==='1'">
                                  <a-button type="text" size="mini" status="normal" class="button-table-option">
                                    <template #icon>
                                      <icon-swap/>
                                    </template>
                                    协同工单转普通工单
                                  </a-button>
                                </a-doption>
                                <a-doption @click="convertNormalToCollaborative(record)" v-else>
                                  <a-button type="text" size="mini" status="normal" class="button-table-option">
                                    <template #icon>
                                      <icon-swap/>
                                    </template>
                                    普通工单转协同工单
                                  </a-button>
                                </a-doption>-->
                <!-- 同步ERP选项 -->
                <a-doption @click="syncErp(record)">
                  <a-button type="text" size="mini" status="normal" class="button-table-option">
                    <template #icon>
                      <icon-send/>
                    </template>
                    同步ERP
                  </a-button>
                </a-doption>
                <!-- 删除 -->
                <a-doption @click="deleteWorkOrderBefore(record)">
                  <a-button type="text" size="mini" status="warning" class="button-table-option">
                    <template #icon>
                      <icon-delete/>
                    </template>
                    删除工单
                  </a-button>
                </a-doption>
              </template>
            </a-dropdown>
          </a-space>
        </template>
      </a-table>

      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>

    <!-- 详情模态框 -->
    <info-modal
        v-model="isShowInfoModal"
        :work-order-id="workOrderInfoCopy.id"
    />

    <!-- 新增/修改项目工单模态框 -->
    <edit-modal
        v-model="isShowEditModal"
        :work-order-id="currentEditWorkOrderId"
        @success="handleEditSuccess"
    />

    <!-- 审批项目工单模态框 -->
    <approval-modal
        v-model="isShowApproveWorkOrderModal"
        :work-order-id="currentEditWorkOrderId"
        @success="handleApprovalSuccess"
    />


    <!-- 导入项目工单模态框 -->
    <import-modal
        v-model="isShowImportModal"
        @success="handleImportSuccess"
    />

    <!-- 删除确认模态框 -->
    <a-modal
        v-model:visible="isShowDeleteWorkOrderModal"
        :on-before-ok="delWorkOrder"
        ok-text="删除"
        @cancel="isShowDeleteWorkOrderModal = false"
        draggable
    >
      <template #title>
        是否删除
      </template>
      <div>确定要删除工单编码为[<strong>{{ workOrderInfoCopy.workorderCode }}</strong>]的工单吗？</div>
    </a-modal>
  </div>
</template>

<script setup>
import chinaAreaData from 'china-area-data'
import {ref, onMounted, computed, watch} from 'vue'
import {
  getWorkOrderPage,
  deleteWorkOrder,
  exportWorkOrderV2,
  convertTempToNormal as apiConvertTempToNormal,
  convertNormalToTemp as apiConvertNormalToTemp,
  convertCollaborativeToNormal as apiConvertCollaborativeToNormal,
  convertNormalToCollaborative as apiConvertNormalToCollaborative,
  genWorkOrderPdf
} from '@/apis/work-order-api'
import {pushWorkOrders} from '@/apis/system/data-sync'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import InfoModal from '@/components/WorkOrder/list/InfoModal.vue'
import EditModal from '@/components/WorkOrder/list/_Edit.vue'
import ImportModal from '@/components/WorkOrder/list/ImportModal.vue'
import ApprovalModal from '@/components/WorkOrder/list/ApprovalModal.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconDelete,
  IconToBottom,
  IconToTop,
  IconEye,
  IconEdit,
  IconSwap,
  IconCheck,
  IconSend,
  IconLoading // 添加这个导入
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {
  timestampNumber2datetimeString,
  timestampNumber2dateString,
  setStartOfDayTimestamp,
  setEndOfDayTimestamp
} from "@/utils/date-util";
import {useCustomerAccountStore, useCustomerStore, useCustomerStoreInfoStore} from "@/store/customer-data";
import {useSysDictDataStore, useSystemOptionsStore} from "@/store/system-data";
import {useProjectServiceOrderStore} from "@/store/work-order-data";
import {useRoute, useRouter} from 'vue-router'
import {useUserDataStore} from "@/store/user-data";

// 条件查询表单折叠
const collapsed = ref(true)

// 模态框显示状态
const isShowInfoModal = ref(false)
const isShowEditModal = ref(false)
const isShowImportModal = ref(false)
const isShowDeleteWorkOrderModal = ref(false)
const isShowApproveWorkOrderModal = ref(false)

// 路由相关
const route = useRoute()
const router = useRouter()

// store
// 系统字典
const sysDictDataStore = useSysDictDataStore();
const systemOptionsStore = useSystemOptionsStore();
// 项目服务单表
const projectServiceOrderStore = useProjectServiceOrderStore();
// 客户信息
const customerStore = useCustomerStore();
// 客户门店信息
const customerStoreInfoStore = useCustomerStoreInfoStore();
// 客户账号
const customerAccountStore = useCustomerAccountStore();
// 用户数据
const userDataStore = useUserDataStore();

// 数据相关
const workOrderInfoCopy = ref({})
const currentEditWorkOrderId = ref(null)
const selectedRowKeys = ref([])
const areaOptions = ref([])
// 添加这个变量来控制ERP同步的加载状态
const erpSyncLoading = ref(false)
// 省市区级联选择相关
const provinceOptions = ref([])
const cityOptions = ref([])
const districtOptions = ref([])

// 初始化省市区选项
const initAreaOptions = () => {
  // 省份选项
  const provinces = chinaAreaData['86'] || {}
  provinceOptions.value = Object.keys(provinces).map(code => ({
    value: provinces[code],
    label: provinces[code]
  }))

  // 如果已选择省份，初始化城市选项
  if (queryForm.value.province) {
    handleProvinceChange(queryForm.value.province)
  }

  // 如果已选择城市，初始化区县选项
  if (queryForm.value.city) {
    handleCityChange(queryForm.value.city)
  }
}

// 处理省份变化
const handleProvinceChange = (selectedProvince) => {
  // 清空城市和区县的选择
  queryForm.value.city = ''
  queryForm.value.district = ''
  cityOptions.value = []
  districtOptions.value = []

  // 查找选中省份的编码
  const provinces = chinaAreaData['86'] || {}
  const provinceCode = Object.keys(provinces).find(code => provinces[code] === selectedProvince)

  if (provinceCode) {
    // 获取城市数据
    const cities = chinaAreaData[provinceCode] || {}
    cityOptions.value = Object.keys(cities).map(code => ({
      value: cities[code],
      label: cities[code]
    }))
  }
}

// 处理城市变化
const handleCityChange = (selectedCity) => {
  // 清空区县的选择
  queryForm.value.district = ''
  districtOptions.value = []

  // 查找选中城市的编码
  // 需要先找到省份编码
  const provinces = chinaAreaData['86'] || {}
  const provinceCode = Object.keys(provinces).find(code => provinces[code] === queryForm.value.province)

  if (provinceCode) {
    const cities = chinaAreaData[provinceCode] || {}
    const cityCode = Object.keys(cities).find(code => cities[code] === selectedCity)

    if (cityCode) {
      // 获取区县数据
      const districts = chinaAreaData[cityCode] || {}
      districtOptions.value = Object.keys(districts).map(code => ({
        value: districts[code],
        label: districts[code]
      }))
    }
  }
}
const timeRangeTypeOptions = [
  {value: 'serviceTime', label: '计划时间段'},
  {value: 'workStartTime', label: '工单开始(签到)时间'},
  {value: 'workEndTime', label: '工单结束时间'},
  {value: 'creatTime', label: '创建时间'}
];
// 下拉框option 数据字典：工单类型
const workOrderTypeOptions = computed(() => {
  return sysDictDataStore.workOrderInfoWorkorderTypeList.map(item => ({value: item.dictValue, label: item.dictLabel}));
});
// 下拉框option 数据字典：工单状态
const workOrderStatusOptions = computed(() => {
  return systemOptionsStore.workStatusList.map(item => ({value: item.code, label: item.description}));
});
const checkinStatusOptions = computed(() => {
  return systemOptionsStore.checkinStatusList.map(item => ({value: item.code, label: item.description}));
});
// 下拉框option 数据字典：工作类别
const workCategoryOptions = computed(() => {
  return sysDictDataStore.workOrderInfoWorkCategoryList.map(item => ({value: item.dictValue, label: item.dictLabel}));
});
// 下拉框option 门店-id
const customerStoreOptions = computed(() => {
  return customerStoreInfoStore.customerStore.map(item => ({value: item.id, label: item.storeName}));
});
// 下拉框option 服务人员
const userOptions = computed(() => {
  return userDataStore.userList.map(item => ({value: item.id, label: item.nickname}));
});
// 下拉框option 数据字典：审批状态
const approvalStatusOptions = computed(() => {
  return sysDictDataStore.workOrderApprovalStatusList.map(item => ({value: item.dictValue, label: item.dictLabel}));
});
// 下拉框option 数据字典：项目服务单-强制协同
const isOvertimeOptions = computed(() => {
  return sysDictDataStore.projectServiceIsOvertimeList.map(item => ({value: item.dictValue, label: item.dictLabel}));
});
// 下拉框option 项目服务单
const projectServiceOrderOptions = computed(() => {
  return projectServiceOrderStore.projectServiceOrderData.map(item => ({
    value: item.id,
    label: `${item.id}-${item.serviceContent || ''}`
  }));
});

// 筛选条件
// 创建时间 范围
const createTimeRange = ref([])
//服务时间范围
const serviceTimeRange = ref([])
//工单开始时间
const workStartTimeRange = ref([])
//工单结束时间
const workEndTimeRange = ref([])
const queryForm = ref({
  workorderCode: '',
  workorderType: '',
  // taskType 已注释而非移除
  // taskType: '',
  workStatuses: [],
  checkinStatuses: [],
  storeId: '',
  workCategory: '',
  projectServiceOrderId: '',
  approvalStatus: '',
  createTimeLeftRange: null,
  createTimeRightRange: null,
  contactPerson: '',
  isOvertime: '',
  timeRangeType: 'serviceTime',
  unitServiceHoursLeftRange: null,
  unitServiceHoursRightRange: null,
  totalServiceCountLeftRange: null,
  totalServiceCountRightRange: null,
  completedServiceCountLeftRange: null,
  completedServiceCountRightRange: null,
  unitPriceLeftRange: null,
  unitPriceRightRange: null,
  province: '',
  city: '',
  district: ''
})

// 用于查询的参数（与v-model绑定参数分离）
const searchParams = ref({
  workorderCode: '',
  workorderType: '',
  workStatuses: '',
  checkinStatuses: '',
  timeRangeType: '',
  storeId: '',
  workCategory: '',
  projectServiceOrderId: '',
  approvalStatus: '',
  createTimeLeftRange: null,
  createTimeRightRange: null,
  contactPerson: '',
  isOvertime: '',
  unitServiceHoursLeftRange: null,
  unitServiceHoursRightRange: null,
  totalServiceCountLeftRange: null,
  totalServiceCountRightRange: null,
  completedServiceCountLeftRange: null,
  completedServiceCountRightRange: null,
  unitPriceLeftRange: null,
  unitPriceRightRange: null,
  province: '',
  city: '',
  district: ''
})

// 项目工单列表数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})

// 加载状态
const loading = ref(false)
const fullscreenLoading = ref(false)

// 列设置相关
const showColumnSetting = ref(false)
const selectedColumns = ref([
  'id',
  'projectServiceOrderId',
  'workorderCode',
  'workorderType',
  // taskType 已注释而非移除
  // 'taskType',
  'workCategory',
  'storeId',
  'serviceTime',
  'workContent',
  'workStatus',
  'approvalStatus',
  'urgent',
  'workLocation',
  'contactPerson',
  'contactPhone',
  'estimatedDuration',
  'actualDuration',
  'servicePersonIds',
  'remark',
  'startTime',
  'endTime',
  'createTime',
  'action'
])

// 所有列定义
const allColumns = ref([
  {title: '项目服务单', dataIndex: 'projectServiceOrderId', width: 130, slotName: 'projectServiceOrderId'},
  {title: '工单编码', dataIndex: 'workorderCode', width: 150, ellipsis: true, tooltip: true},
  {title: '工单类型', dataIndex: 'workorderType', width: 100, slotName: 'workorderType'},
  // 任务类型列已注释
  // {title: '任务类型', dataIndex: 'taskType', width: 100, slotName: 'taskType'},
  {title: '工作类别', dataIndex: 'workCategory', width: 100, slotName: 'workCategory'},
  {title: '所属门店', dataIndex: 'storeName', width: 180, ellipsis: true, tooltip: true},
  {title: '计划时间段', dataIndex: 'serviceTime', width: 150, slotName: 'serviceTime'},
  {title: '工作内容', dataIndex: 'workContent', width: 200, ellipsis: true, tooltip: true},
  {title: '工单状态', dataIndex: 'workStatus', width: 100, slotName: 'workStatus'},
  {title: '审批状态', dataIndex: 'approvalStatus', width: 100, slotName: 'approvalStatus'},
  {title: '签到校验', dataIndex: 'invalidCount', width: 100, slotName: 'invalidCount'},
  {title: '是否紧急', dataIndex: 'urgent', width: 90, slotName: 'urgent'},
  {title: '省', dataIndex: 'province', width: 80},
  {title: '市', dataIndex: 'city', width: 80},
  {title: '区', dataIndex: 'district', width: 80},
  {title: '工作地点', dataIndex: 'workLocation', width: 200, ellipsis: true, tooltip: true},
  // {title: '联系人', dataIndex: 'contactPerson', width: 100},
  // {title: '联系电话', dataIndex: 'contactPhone', width: 130},
  // {title: '预计工时', dataIndex: 'estimatedDuration', width: 150, slotName: 'estimatedDuration'},
  // {title: '实际工时', dataIndex: 'actualDuration', width: 150, slotName: 'actualDuration'},
  {title: '技术人员', dataIndex: 'servicePersonIds', width: 150, slotName: 'servicePersonIds'},
  {title: '审批人员', dataIndex: 'approverIds', width: 150, slotName: 'approverIds'},
  {title: '备注', dataIndex: 'remark', width: 150, ellipsis: true, tooltip: true},
  {title: '工单开始时间', dataIndex: 'startTime', width: 160, slotName: 'startTime'},
  {title: '工单结束时间', dataIndex: 'endTime', width: 160, slotName: 'endTime'},
  {title: '创建人', dataIndex: 'createBy', width: 160, slotName: 'createBy'},
  {title: '创建时间', dataIndex: 'createTime', width: 160, slotName: 'createTime'},
  {title: '操作', dataIndex: 'action', width: 260, slotName: 'action', align: 'center', fixed: 'right', required: true}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// 获取项目工单列表
const fetchTableData = async () => {
  handleParam()

  loading.value = true

  var params = {
    ...searchParams.value
  }
  if (params.city === "市辖区") {
    params.city = '';
  }
  try {
    console.log('params', params)
    const response = await getWorkOrderPage({
      ...params,
      current: pagination.value.current,
      size: pagination.value.size
    })

    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
    } else {
      Message.error(response.message || '获取项目工单列表失败');
      console.error('获取项目工单列表失败:', error)
    }
  } catch (error) {
    loading.value = false;
    Message.error(error.message || '获取项目工单列表失败');
    console.error('获取项目工单列表失败:', error)
  }
}

// 处理查询参数
const handleParam = () => {
  if (createTimeRange.value.length > 0) {
    searchParams.value.createTimeLeftRange = setStartOfDayTimestamp(createTimeRange.value[0])
    searchParams.value.createTimeRightRange = setEndOfDayTimestamp(createTimeRange.value[1])
  } else {
    searchParams.value.createTimeLeftRange = null
    searchParams.value.createTimeRightRange = null
  }
  if (serviceTimeRange.value.length > 0) {
    searchParams.value.serviceTimeLeftRange = setStartOfDayTimestamp(serviceTimeRange.value[0])
    searchParams.value.serviceTimeRightRange = setEndOfDayTimestamp(serviceTimeRange.value[1])
  } else {
    searchParams.value.serviceTimeLeftRange = null
    searchParams.value.serviceTimeRightRange = null
  }

  // 处理工单状态多选参数
  for (const spkey of ['workStatuses', 'checkinStatuses']) {
    if (Array.isArray(queryForm.value[spkey]) && queryForm.value[spkey].length > 0) {
      searchParams.value[spkey] = queryForm.value[spkey].join(',')
    } else {
      searchParams.value[spkey] = ''
    }
  }

  // 复制其他参数
  const excludeKeys = ['workStatuses','checkinStatuses', 'createTimeLeftRange', 'createTimeRightRange', 'serviceTimeLeftRange', 'serviceTimeRightRange'];
  Object.keys(queryForm.value).forEach(key => {
    if (!excludeKeys.includes(key)) {
      searchParams.value[key] = queryForm.value[key];
    }
  });
}

// 搜索项目工单
const handleQuery = () => {
  pagination.value.current = 1
  fetchTableData()
  updateRouteQuery()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    if (key.includes('Range')) {
      queryForm.value[key] = null
    } else {
      queryForm.value[key] = ''
    }
  })
  queryForm.value.workStatuses = [];
  queryForm.value.checkinStatuses = [];
  createTimeRange.value = []
  pagination.value.current = 1
  fetchTableData()
  updateRouteQuery()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
  updateRouteQuery()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.value.current = 1
  fetchTableData()
  updateRouteQuery()
}

// 更新路由查询参数
const updateRouteQuery = () => {
  const query = {}

  // 添加分页参数
  if (pagination.value.current !== 1) {
    query.page = pagination.value.current
  }
  if (pagination.value.size !== 10) {
    query.size = pagination.value.size
  }

  // 添加筛选参数 (从queryForm获取，用于保持UI状态)
  Object.keys(queryForm.value).forEach(key => {
    if (queryForm.value[key] !== '' && queryForm.value[key] !== null && queryForm.value[key] !== undefined) {
      // 特殊处理工单状态数组参数
      if (Array.isArray(queryForm.value[key]) && ['workStatuses','checkinStatuses']) {
        if (queryForm.value[key].length > 0) {
          query[key] = queryForm.value[key].join(',')
        }
      } else {
        query[key] = queryForm.value[key]
      }
    }
  })

  // 添加时间范围参数
  if (createTimeRange.value.length > 0) {
    query.createTimeRange = createTimeRange.value.join(',')
  }

  router.replace({query})
}

// 从路由参数恢复筛选条件
const restoreFromRouteQuery = () => {
  const query = route.query

  // 恢复分页参数
  if (query.page) {
    pagination.value.current = parseInt(query.page)
  }
  if (query.size) {
    pagination.value.size = parseInt(query.size)
  }

  // 恢复筛选参数到queryForm（用于v-model绑定）
  Object.keys(queryForm.value).forEach(key => {
    if (query[key] !== undefined) {
      if (key.includes('Range') && key !== 'createTimeLeftRange' && key !== 'createTimeRightRange') {
        queryForm.value[key] = parseFloat(query[key]) || null
      } else if (key === 'isOvertime') {
        queryForm.value[key] = query[key] === 'true' ? true : query[key] === 'false' ? false : query[key]
      } else if (key === 'workStatuses' || key === 'checkinStatuses') {
        // 处理工单状态多选参数，将逗号分隔的字符串转为数组
        if (query[key]) {
          queryForm.value[key] = query[key].split(',')
        } else {
          queryForm.value[key] = []
        }
      } else {
        queryForm.value[key] = query[key]
      }
    }
  })

  // 恢复时间范围参数
  if (query.createTimeRange) {
    createTimeRange.value = query.createTimeRange.split(',')
  }
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  localStorage.setItem('workOrderInfoColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 格式化方法
const getWorkorderTypeText = (workorderType) => {
  // 使用pinia中的数据字典替代硬编码映射
  const dictItem = sysDictDataStore.workOrderInfoWorkorderTypeMap.get(workorderType + "");
  return dictItem ? dictItem.dictLabel : '未知';
}

const getWorkStatusText = (status) => {
  // 使用pinia中的数据字典替代硬编码映射
  const dictItem = sysDictDataStore.workOrderInfoWorkStatusMap.get(status + "");
  return dictItem ? dictItem.dictLabel : '未知';
}

// 任务类型文本获取方法已注释
/*
const getTaskTypeText = (taskType) => {
  const dictItem = sysDictDataStore.workOrderInfoTaskTypeMap.get(taskType + "");
  return dictItem ? dictItem.dictLabel : '未知';
}
*/

const getStoreName = (storeId) => {
  const store = customerStoreInfoStore.customerStoreIdMap.get(storeId);
  return store ? store.storeName : storeId;
}

const getWorkCategoryText = (workCategory) => {
  const dictItem = sysDictDataStore.workOrderInfoWorkCategoryMap.get(workCategory + "");
  return dictItem ? dictItem.dictLabel : '未知';
}

const getProjectServiceOrderText = (projectServiceOrderId) => {
  const serviceOrder = projectServiceOrderStore.projectServiceOrderDataIdMap.get(projectServiceOrderId + "");
  return serviceOrder ? `${serviceOrder.id}-${serviceOrder.serviceContent || ''}` : projectServiceOrderId;
}

const getWorkStatusColor = (status) => {
  // 颜色映射可以根据需要调整
  const colorMap = {'1': 'blue', '2': 'cyan', '3': 'orange', '4': 'orange', '5': 'green', '6': 'red'}
  return colorMap[status] || 'gray'
}
const getCheckinStatusText = (status) => {
  // 使用pinia中的数据字典替代硬编码映射
  const item = systemOptionsStore.checkinStatusMap.get(status + "");
  return item ? item.description : '未知';
}
const getCheckinStatusColor = (status) => {
  // 颜色映射可以根据需要调整
  const colorMap = {'0': 'gray','1': 'green', '2': 'red'}
  return colorMap[status] || 'gray'
}

const getApprovalStatusText = (row) => {
  if (row.workStatus === '1' || row.workStatus === '2') {
    return "无";
  }
  const dictItem = sysDictDataStore.workOrderApprovalStatusMap.get(row.approvalStatus + "");
  return dictItem ? dictItem.dictLabel : '待审批';
}

const getApprovalStatusColor = (status) => {
  const colorMap = {1: 'gray', 2: 'orange', 3: 'green', 4: 'red'}
  return colorMap[status] || 'gray'
}

const formatDate = (dateString) => {
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}
const formatDateTime = (dateString) => {
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2datetimeString(dateString)
}

const formatDuration = (minutes) => {
  if (!minutes) return '—';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}小时${mins}分钟` : `${mins}分钟`;
}

// 用户名称获取函数（支持逗号分隔的多个用户ID）
const getUserText = (userId) => {
  if (!userId) return '—';

  // 如果是逗号分隔的多个用户ID
  if (userId.includes(',')) {
    const userIds = userId.split(',');
    const userNames = userIds.map(id => {
      const user = userDataStore.userIdMap.get(id.trim());
      return user ? (user.nickname || user.username) : id.trim();
    });
    return userNames.join(', ');
  }

  // 单个用户ID
  const user = userDataStore.userIdMap.get(userId + "");
  return user ? (user.nickname || user.username) : userId || '—';
}

// 详情
const showInfoBefore = (workOrder) => {
  workOrderInfoCopy.value = workOrder
  isShowInfoModal.value = true
}



// 查看pdf
const showPdfView = (workOrder) => {
  // 在新窗口中打开PDF而不是使用模态框
  if (workOrder.pdfUrl) {
    window.open(workOrder.pdfUrl, '_blank');
  } else {
    Message.warning('暂无PDF文件');
  }
}



// 新增项目工单
const addWorkOrder = () => {
  currentEditWorkOrderId.value = null
  isShowEditModal.value = true
}

// 编辑项目工单
const editWorkOrder = (workOrder) => {
  currentEditWorkOrderId.value = workOrder.id
  isShowEditModal.value = true
}

// 导入项目工单
const importWorkOrderInfo = () => {
  isShowImportModal.value = true
}

// 审批按钮是否禁用
const approveButtonStatus = (record) => {
  // TODO 待替换数据字典
  // const map = {1: '待审批', 2: '待补充材料', 3: '已通过', 4: '已拒绝'}
  const map = {1: false, 2: true, 3: true, 4: true}
  return record?.workStatus !== "3";
}
// 审批项目工单
const approveWorkOrder = (workOrder) => {
  currentEditWorkOrderId.value = workOrder.id
  isShowApproveWorkOrderModal.value = true
}

// 导出项目工单
const exportWorkOrderInfo = async () => {
  try {
    // 使用searchParams而不是queryForm
    handleParam()
    let params = {
      ...searchParams.value
    }
    if (params.city === "市辖区") {
      params.city = '';
    }
    if (selectedRowKeys.value.length > 0) {
      params.ids = selectedRowKeys.value
    }
    fullscreenLoading.value = true
    const response = await exportWorkOrderV2(params)
    const blob = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `项目工单数据_${new Date().toJSON().slice(0, 23).replaceAll(":", "")}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    Message.success('项目工单数据导出成功')
    selectedRowKeys.value = []
    fullscreenLoading.value = false
  } catch (error) {
    fullscreenLoading.value = false
    Message.error('导出项目工单数据失败')
    console.error('导出失败:', error)
  }
}

// 删除项目工单
const deleteWorkOrderBefore = (workOrder) => {
  workOrderInfoCopy.value = workOrder
  isShowDeleteWorkOrderModal.value = true
}

const delWorkOrder = async () => {
  try {
    const response = await deleteWorkOrder(workOrderInfoCopy.value.id)
    if (response.code === 0) {
      Message.success('删除项目工单成功')
      fetchTableData()
      return true
    } else {
      Message.error(response.message || '删除项目工单失败')
      return false
    }
  } catch (error) {
    Message.error('删除项目工单失败')
    console.error('删除失败:', error)
    return false
  }
}

// 工单类型转换操作
const convertTempToNormal = async (workOrder) => {
  try {
    const response = await apiConvertTempToNormal(workOrder.id)
    if (response.code === 0) {
      Message.success('临时工单转普通工单成功')
      fetchTableData()
    } else {
      Message.error(response.message || '操作失败')
    }
  } catch (error) {
    Message.error('操作失败')
    console.error('转换失败:', error)
  }
}

// 同步ERP功能
const syncErp = async (workOrder) => {
  try {
    erpSyncLoading.value = true
    const response = await pushWorkOrders({ids: [workOrder.id], pushAll: true})
    if (response.code === 0) {
      Message.success('ERP同步成功')
    } else {
      Message.error(response.message || 'ERP同步失败')
    }
  } catch (error) {
    Message.error('ERP同步失败: ' + (error.message || '未知错误'))
    console.error('ERP同步失败:', error)
  } finally {
    erpSyncLoading.value = false
  }
}

const convertNormalToTemp = async (workOrder) => {
  try {
    const response = await apiConvertNormalToTemp(workOrder.id)
    if (response.code === 0) {
      Message.success('普通工单转临时工单成功')
      fetchTableData()
    } else {
      Message.error(response.message || '操作失败')
    }
  } catch (error) {
    Message.error('操作失败')
    console.error('转换失败:', error)
  }
}

const convertCollaborativeToNormal = async (workOrder) => {
  try {
    const response = await apiConvertCollaborativeToNormal(workOrder.id)
    if (response.code === 0) {
      Message.success('协同工单转普通工单成功')
      fetchTableData()
    } else {
      Message.error(response.message || '操作失败')
    }
  } catch (error) {
    Message.error('操作失败')
    console.error('转换失败:', error)
  }
}

const convertNormalToCollaborative = async (workOrder) => {
  try {
    const response = await apiConvertNormalToCollaborative(workOrder.id)
    if (response.code === 0) {
      Message.success('普通工单转协同工单成功')
      fetchTableData()
    } else {
      Message.error(response.message || '操作失败')
    }
  } catch (error) {
    Message.error('操作失败')
    console.error('转换失败:', error)
  }
}

// 成功回调
const handleEditSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}

const handleImportSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}
const handleApprovalSuccess = () => {
  fetchTableData()
  // selectedRowKeys.value = []
}
const handleAreaChange = () => {
  // 允许选择任意一级，将选中的值更新到查询表单中
  var value = areaCascaderValue.value;
  console.log('Selected area values:', value);
  if (value && value.length > 0) {
    // 清空之前的地区筛选条件
    queryForm.value.province = '';
    queryForm.value.city = '';
    queryForm.value.district = '';

    // 根据选择的级别设置对应的地区筛选条件
    if (value.length >= 1) {
      queryForm.value.province = value[0];
    }
    if (value.length >= 2 && value[1] !== '市辖区') {
      queryForm.value.city = value[1];
    }
    if (value.length >= 3) {
      queryForm.value.district = value[2];
    }
  } else {
    // 如果没有选择任何值，清空地区筛选条件
    queryForm.value.province = '';
    queryForm.value.city = '';
    queryForm.value.district = '';
  }
  console.log('Selected area values:', value);
  console.log('Query form area values:', queryForm.value.province, queryForm.value.city, queryForm.value.district);
}

// 监听路由参数变化
watch(() => route.query, () => {
  restoreFromRouteQuery()
  fetchTableData()
}, {immediate: true})


// 组件挂载时获取数据
onMounted(() => {
  // 初始化省市区选项
  initAreaOptions()

  // 从本地存储加载列设置
  const savedColumns = localStorage.getItem('workOrderInfoColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  // 从路由参数恢复筛选条件
  restoreFromRouteQuery()
  fetchTableData()
})

</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  padding: 0;
}

.fullscreen-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fullscreen-spin-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fullscreen-spin-container :deep(.arco-spin-icon) {
  font-size: 36px;
  color: #1890ff;
}

.fullscreen-spin-container :deep(.arco-spin-tip) {
  margin-top: 16px;
  font-size: 16px;
  color: #333;
}
</style>